export default [
  {
    path: 'product_maps',
    meta: { label: 'Product Maps' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'product maps',
        meta: { permission: 'show_all_product_maps' },
        component: () => import('./../../views/product_maps/ProductMaps'),
      },
      {
        path: 'create',
        meta: { label: 'Create Product Map', permission: 'create_product_maps' },
        name: 'CreateProductMap',
        component: () => import('./../../views/product_maps/CreateProductMap'),
      },
      {
        path: ':id',
        meta: { label: 'Show Product Map', permission: 'show_single_product_maps' },
        name: 'ProductMap',
        component: () => import('./../../views/product_maps/ProductMap'),
      },
      {
        path: ':id/edit',
        meta: { label: 'Edit Product Map', permission: 'edit_product_maps' },
        name: 'EditProductMap',
        component: () => import('./../../views/product_maps/EditProductMap'),
      },
    ]
  },
]
